import React, { useState } from 'react';
import Header from './Header'
import Note from './Note';
import Footer from './Footer';
import CreateNote from './CreateNote';

function App() {
    const [notes, setNotes] = useState([]);

    function addNewNote(newNote){
        setNotes(prevNotes => {
            return [...prevNotes, newNote];
        })
    }

    function deleteNote(id) {
        setNotes((prevNotes) => {
          return prevNotes.filter((noteItem, index) => {
            return index !== id;
          });
        });
    }

    return (
        <div>
            <Header />
            <CreateNote onAdd={addNewNote} />
            {notes.map((noteItem, index) => {
                return (
                    <Note 
                        key={index}
                        id={index}
                        title={noteItem.title}
                        content={noteItem.content} 
                        onDelete={deleteNote}
                        // title={noteItem['title']}
                        // content={noteItem['content']}  
                    />
                );
            })}
            <Footer />
        </div>
    )
}

export default App;